import Step2 from './Step2-compose';

export default Step2;
